import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Classes from 'classnames';


class InputInlineEditable extends React.Component {
    static propTypes = {
        value: PropTypes.string,
        disabled: PropTypes.bool,
        placeholder: PropTypes.string,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        commitDelay: PropTypes.number,
        autoSaveChanges: PropTypes.bool,
        onImmediateChange: PropTypes.func,
        autofocus: PropTypes.bool,
    };

    static defaultProps = {
        disabled: false,
        commitDelay: 600,
        autoSaveChanges: true
    };

    state = {
        value: this.props.value
    };

    UNSAFE_componentWillMount() {
        this.commited = true;
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.commited && this.state.value !== newProps.value)
            this.setState({value: newProps.value});
    }

    componentDidMount() {
        this.debounceOnChange = _.debounce(this.commitOnChange, this.props.commitDelay);

        if (this.props.autofocus) this.focus();
    }

    commitOnChange = (newValue) => {
        this.commited = true;
        if (this.props.onChange) this.props.onChange(newValue ? newValue.trim() : newValue);
    };

    focus = () => {
        this.refs.input.focus();
    };

    onFocus = (e) => {
        const { onFocus } = this.props;
        if (onFocus) onFocus(e)
    };

    onBlur = (e) => {
        const { onBlur, autoSaveChanges } = this.props;
        if (onBlur) onBlur(e);

        if (autoSaveChanges){
            this.debounceOnChange.cancel();
            this.commitOnChange(this.state.value);
        }
    };

    onInputKeyDown = (e) => {
        const { autoSaveChanges } = this.props;

        if (e.keyCode === 13) {
            this.refs.input.blur();
            if (!autoSaveChanges) this.commitOnChange(this.state.value);
        }
    };

    onChange = (event) => {
        const { onImmediateChange, autoSaveChanges } = this.props;
        this.commited = false;
        const newValue = event.target.value;
        if (autoSaveChanges) this.debounceOnChange(newValue);
        this.setState({value:newValue}, ()=>{
            if (onImmediateChange) onImmediateChange(newValue);
        });
    };

    render() {
        const { disabled, placeholder, className } = this.props;
        const { value } = this.state;

        const classes = Classes('gd-inline-input',className, {
            empty: value === null || value === undefined,
            disabled: disabled
        });
        //asd

        return (
            <input ref="input"
                   className={classes}
                   style={this.props.style}
                   placeholder={placeholder}
                   value={value !== null && value !== undefined ? value : ""}
                   disabled={disabled}
                   onKeyDown={this.onInputKeyDown}
                   onFocus={this.onFocus}
                   onBlur={this.onBlur}
                   onChange={this.onChange}/>
        );
    }
}

module.exports = InputInlineEditable;